// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2fLpO","legacyBtn":"MutateMid_legacyBtn__1b6JV"};